<template>
  <div class="bpm-bubble-component">
    <!-- Cercle BPM basé sur les styles fournis -->
    <div id="cercleBPM" :class="{ 'no-signal': isBpmLow }">
      <!-- Image appareil non détecté - visible uniquement quand pas de signal -->
      <img
        src="../../../assets/img/noDeviceFound.png"
        id="imageBPM"
        :style="{ display: isBpmLow ? 'block' : 'none' }"
      />

      <!-- Conteneur pour centrer le BPM et le label -->
      <div class="bpm-content" :style="{ display: isBpmLow ? 'none' : 'flex' }">
        <span id="BpmInstant">{{ bpm }}</span>
        <span id="bpm">BPM</span>
      </div>

      <!-- Image pas de signal - visible uniquement quand pas de signal -->
      <img
        src="../../../assets/img/LogoPasDeSignal.png"
        id="petite-image"
        :style="{ display: isBpmLow ? 'block' : 'none' }"
      />
    </div>

    <!-- Message d'avertissement supprimé -->
  </div>
</template>

<script>
export default {
  name: "BpmBubble",
  props: {
    bpm: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  computed: {
    isBpmLow() {
      return this.bpm <= 30;
    },
  },
};
</script>

<style scoped>
.bpm-bubble-component {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: relative;
}

#cercleBPM {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  background: #489181; /* Couleur par défaut quand le capteur est actif */
  border: 10px solid #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 0 10px #00000094;
  transition: all 0.3s ease;
}

/* Style quand il n'y a pas de signal */
#cercleBPM.no-signal {
  border-color: red;
  background: white;
}

/* Conteneur pour centrer la valeur et le texte BPM */
.bpm-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
}

#bpm {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 2px;
}

#BpmInstant {
  font-size: 48px;
  font-weight: bold;
  color: white;
  line-height: 1;
}

#imageBPM {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* CSS exact pour petite-image selon le code fourni */
#petite-image {
  height: 50px;
  width: 50px;
  position: absolute;
  bottom: 0;
  right: 0;
  border: 2px solid red;
  border-radius: 50%;
  background-color: #fff;
}

/* Classes warning-message et warning-icon conservées au cas où elles seraient utilisées ailleurs */
.warning-message {
  display: none; /* Caché plutôt que supprimé complètement au cas où la classe serait référencée ailleurs */
}

.warning-icon {
  display: none;
}

/* Responsive */
@media (max-width: 768px) {
  #cercleBPM {
    height: 120px;
    width: 120px;
    border-width: 8px;
  }

  #BpmInstant {
    font-size: 36px;
  }

  #bpm {
    font-size: 14px;
  }

  #petite-image {
    height: 40px;
    width: 40px;
  }
}

@media (max-width: 480px) {
  #cercleBPM {
    height: 100px;
    width: 100px;
    border-width: 6px;
  }

  #BpmInstant {
    font-size: 28px;
  }

  #bpm {
    font-size: 12px;
  }

  #petite-image {
    height: 30px;
    width: 30px;
  }
}
</style>